<div class="page-content">
  <!-- PAGE HEADER -->
  <div class="page_header">
    <div class="page_header_text">
      <h1>Escalas</h1>
      <span>Gestão de escalas operacionais dos efetivos</span>
    </div>
  </div>

  <!-- KPIs -->
  <div class="kpi-grid mini" style="margin-bottom: 18px">
    <div class="kpi-card mini">
      <div class="kpi-icon blue">
        <i class="fas fa-calendar-days"></i>
      </div>
      <div class="kpi-info">
        <span>Escalas no período</span>
        <strong>{{ totalRecordsCount }}</strong>
      </div>
    </div>
    <div class="kpi-card mini">
      <div class="kpi-icon green">
        <i class="fas fa-play-circle"></i>
      </div>
      <div class="kpi-info">
        <span>A decorrer</span>
        <strong>{{ escalaAtivasCount }}</strong>
      </div>
    </div>
    <div class="kpi-card mini">
      <div class="kpi-icon blue">
        <i class="fas fa-calendar-check"></i>
      </div>
      <div class="kpi-info">
        <span>Agendadas</span>
        <strong>{{ escalaAgendadasCount }}</strong>
      </div>
    </div>
    <div class="kpi-card mini">
      <div class="kpi-icon green">
        <i class="fas fa-map-marker-alt"></i>
      </div>
      <div class="kpi-info">
        <span>Postos activos</span>
        <strong>{{ postos.length }}</strong>
      </div>
    </div>
  </div>

  <!-- FILTROS -->
  <div class="filters-bar">
    <div class="month-nav">
      <button class="btn-icon" (click)="mesAnterior()" title="Mês anterior">
        <i class="ri-arrow-left-s-line"></i>
      </button>
      <span class="month-label">{{ mesLabel }}</span>
      <button class="btn-icon" (click)="mesSeguinte()" title="Mês seguinte">
        <i class="ri-arrow-right-s-line"></i>
      </button>
    </div>

    <p-select
      [options]="postos"
      [(ngModel)]="filtroPosto"
      optionLabel="nome"
      optionValue="id"
      placeholder="Todos os postos"
      [showClear]="true"
      (onChange)="load()"
      styleClass="filter-drop"
    >
    </p-select>

    <button class="btn-web-secondary" (click)="showFilters = true">
      <i class="ri-filter-3-line"></i> Filtros
      <span class="filter-badge" *ngIf="hasActiveFilters">•</span>
    </button>

    <button class="btn-web-secondary" (click)="limparFiltros()">
      <i class="fas fa-undo"></i> Limpar
    </button>
  </div>

  <!-- CARDS -->
  <div class="sp-card escalas-wrap">
    <!-- SKELETON -->
    <div *ngIf="loading" class="skeleton-rows">
      @for (i of [1, 2, 3, 4, 5]; track i) {
        <p-skeleton height="72px" styleClass="mb-2"></p-skeleton>
      }
    </div>

    <!-- LISTA DE CARDS -->
    <div class="escalas-list" *ngIf="!loading && escalas.length > 0">
      @for (e of escalas; track e.id) {
        <div class="escala-card" [ngClass]="getEstadoClass(e.estado, e.estadoDescricao)"
          role="link"
          tabindex="0"
          [attr.aria-label]="'Ver detalhe da escala ' + e.id"
          (click)="abrirDetalheEscala($event, e)"
          (keydown)="abrirDetalheEscala($event, e)"
          [class.card-vazia]="!e.efetivos?.length"
        >
          <!-- Col 1: Avatares dos efetivos -->
          <div class="ec-avatars-col">
            <ng-container
              *ngIf="e.efetivos && e.efetivos.length > 0; else semEfetivo"
            >
              <div class="ec-avatar-stack">
                <div
                  class="ec-avatar"
                  *ngFor="let ef of e.efetivos.slice(0, 3); let i = index"
                  [style.zIndex]="3 - i"
                  [style.marginLeft]="i > 0 ? '-12px' : '0'"
                  [title]="ef.nome"
                >
                  {{ getInitials(ef.nome) }}
                </div>
                <div
                  class="ec-avatar ec-avatar-more"
                  *ngIf="e.efetivos.length > 3"
                  [title]="e.efetivos.length + ' efetivos'"
                >
                  +{{ e.efetivos.length - 3 }}
                </div>
              </div>
            </ng-container>
            <ng-template #semEfetivo>
              <div class="ec-avatar ec-avatar-empty" title="Sem efetivos">
                <i class="fas fa-user-plus"></i>
              </div>
            </ng-template>
          </div>

          <!-- Col 2: Nomes + Posto -->
          <div class="ec-info-col">
            <span class="ec-nomes" *ngIf="e.efetivos && e.efetivos.length > 0">
              {{ e.efetivos[0].nome | titlecase }}
              <span class="ec-nomes-more" *ngIf="e.efetivos.length > 1">
                +{{ e.efetivos.length - 1 }} efetivo(s)
              </span>
            </span>
            <span class="ec-nomes ec-sem-ef" *ngIf="!e.efetivos?.length">
              <i class="fas fa-user-plus"></i> Sem efetivos escalados
            </span>
            <span class="ec-posto">
              <i class="ri-map-pin-2-line"></i> {{ getNomePosto(e) }}
            </span>
          </div>

          <!-- Col 3: Período -->
          <div class="ec-periodo-col">
            <span class="ec-dates">
              <i class="ri-calendar-event-line"></i>
              {{ formatDate(e.dataInicio) }} →
              {{ formatDate(e.dataFim ?? e.dataTermino) }}
            </span>
            <span class="ec-duracao">{{ getDuracao(e) }}</span>
          </div>

          <!-- Col 4: Turno + Equipamentos -->
          <div class="ec-meta-col">
            <span class="ec-turno" *ngIf="e.nomeTurno">
              <i class="fas fa-clock"></i> {{ e.nomeTurno }}
            </span>
            <span class="ec-equip" *ngIf="getEquipamentosEscala(e)">
              <i class="ri-tools-line"></i> {{ getEquipamentosEscala(e) }}
            </span>
          </div>

          <!-- Col 5: Estado + Avaliação -->
          <div class="ec-status-col">
            <span class="estado-pill" [ngClass]="getEstadoClass(e.estado, e.estadoDescricao)">
              <span class="estado-dot"></span>
              {{ getEstadoLabel(e) }}
            </span>
            <div class="avaliacao-stars" *ngIf="getAvaliacaoEscala(e) > 0">
              <i
                class="ri-star-fill"
                *ngFor="
                  let s of [1, 2, 3, 4, 5].slice(0, getAvaliacaoEscala(e))
                "
              ></i>
            </div>
          </div>

          <!-- Col 6: Menu kebab -->
          <div class="ec-menu">
            <button class="btn-kebab" (click)="abrirMenu($event, e)">
              <i class="fas fa-ellipsis-v"></i>
            </button>
          </div>
        </div>
      }
    </div>

    <!-- Instância única do menu kebab — renderizado no body via appendTo -->
    <p-menu
      #kebabMenu
      [popup]="true"
      [model]="menuItems"
      appendTo="body"
      styleClass="escala-kebab-menu"
    ></p-menu>

    <div class="escalas-paginator" *ngIf="totalRecords > pageSize">
      <p-paginator
        [rows]="pageSize"
        [totalRecords]="totalRecords"
        [rowsPerPageOptions]="[10, 20, 50]"
        [first]="(page - 1) * pageSize"
        (onPageChange)="onPageChange($event)"
        styleClass="sp-paginator"
      >
      </p-paginator>
    </div>

    <app-empty-state
      *ngIf="!loading && escalas.length === 0"
      icon="ri-calendar-line"
      title="Nenhuma escala registada"
      message="Não existem escalas para o período e filtros seleccionados."
    ></app-empty-state>
  </div>

  <!-- PAINEL DE FILTROS -->
  <app-filter-panel
    [(visible)]="showFilters"
    title="Filtrar Escalas"
    (applyFilters)="applyFilters()"
    (clearFilters)="limparFiltros()"
  >
    <div class="form-group">
      <label>Cliente</label>
      <p-select
        [(ngModel)]="filtroCliente"
        [options]="clientes"
        optionLabel="nome"
        optionValue="id"
        placeholder="Todos os clientes"
        [showClear]="true"
        [filter]="true"
        filterPlaceholder="Pesquisar cliente..."
        styleClass="w-full"
        appendTo="body"
      >
      </p-select>
    </div>

    <div class="form-group" style="margin-top: 12px">
      <label>Efetivo</label>
      <p-select
        [(ngModel)]="filtroEfetivo"
        [options]="efetivos"
        optionLabel="nome"
        optionValue="id"
        placeholder="Todos os efetivos"
        [showClear]="true"
        [filter]="true"
        filterPlaceholder="Pesquisar efetivo..."
        styleClass="w-full"
        appendTo="body"
      >
      </p-select>
    </div>

    <div class="sp-filter-grid-2" style="margin-top: 12px">
      <div class="form-group">
        <label>Cobertura</label>
        <p-select
          [(ngModel)]="filtroCobertura"
          [options]="coberturaFiltroOpts"
          optionLabel="label"
          optionValue="value"
          placeholder="Todas"
          [showClear]="true"
          styleClass="w-full"
          appendTo="body"
        >
        </p-select>
      </div>
      <div class="form-group">
        <label>Estado</label>
        <p-select
          [(ngModel)]="filtroEstado"
          [options]="estadoOpts"
          optionLabel="label"
          optionValue="value"
          placeholder="Todos"
          [showClear]="true"
          styleClass="w-full"
          appendTo="body"
        >
        </p-select>
      </div>
    </div>
  </app-filter-panel>

  <!-- DRAWER CRIAR / EDITAR -->
  <p-drawer
    [header]="editing ? 'Editar Escala' : 'Nova Escala'"
    [(visible)]="showDialog"
    position="right"
    [modal]="true"
    [style]="{ width: '640px' }"
    styleClass="efetivo-drawer-dark"
  >
    <form [formGroup]="form" class="dialog-form">
      <!-- Efetivo + Posto -->
      <div class="form-grid-2">
        <div class="form-group">
          <label>Efetivo <span class="req">*</span></label>
          <p-select
            formControlName="idEfetivo"
            [options]="efetivos"
            optionLabel="nome"
            optionValue="id"
            placeholder="Seleccionar efetivo"
            [filter]="true"
            filterPlaceholder="Pesquisar nome..."
            styleClass="w-full"
            appendTo="body"
          >
            <ng-template pTemplate="selectedItem" let-ef>
              <div class="ef-option" *ngIf="ef">
                <div class="ef-opt-av">{{ getInitials(ef.nome) }}</div>
                <span>{{ ef.nome }}</span>
              </div>
            </ng-template>
            <ng-template pTemplate="item" let-ef>
              <div class="ef-option">
                <div class="ef-opt-av">{{ getInitials(ef.nome) }}</div>
                <div>
                  <div style="font-weight: 500">{{ ef.nome }}</div>
                  <div style="font-size: 11px; color: var(--sp-muted)">
                    BI: {{ ef.numBI }}
                  </div>
                </div>
              </div>
            </ng-template>
          </p-select>
          <small class="field-error" *ngIf="hasError('idEfetivo')"
            >Campo obrigatório</small
          >
        </div>

        <div class="form-group">
          <label>Posto <span class="req">*</span></label>
          <p-select
            formControlName="idPosto"
            [options]="postos"
            optionLabel="nome"
            optionValue="id"
            placeholder="Seleccionar posto"
            [filter]="true"
            filterPlaceholder="Pesquisar posto..."
            styleClass="w-full"
            appendTo="body"
          >
            <ng-template pTemplate="item" let-p>
              <div
                style="
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  gap: 8px;
                "
              >
                <span>{{ p.nome }}</span>
                <span
                  class="badge badge-risco-{{
                    (p.risco || 'baixo').toLowerCase()
                  }}"
                  style="font-size: 10px"
                  >{{ p.risco }}</span
                >
              </div>
            </ng-template>
          </p-select>
          <small class="field-error" *ngIf="hasError('idPosto')"
            >Campo obrigatório</small
          >
        </div>
      </div>

      <!-- Datas -->
      <div class="form-grid-2">
        <div class="form-group">
          <label>Data Início <span class="req">*</span></label>
          <p-datepicker
            formControlName="dataInicio"
            dateFormat="dd/mm/yy"
            [showIcon]="true"
            styleClass="w-full"
            appendTo="body" [autoZIndex]="true" [baseZIndex]="1000010" panelStyleClass="drawer-datepicker-panel"
          >
          </p-datepicker>
          <small class="field-error" *ngIf="hasError('dataInicio')"
            >Campo obrigatório</small
          >
        </div>

        <div class="form-group">
          <label>Data Término <span class="req">*</span></label>
          <p-datepicker
            formControlName="dataTermino"
            dateFormat="dd/mm/yy"
            [showIcon]="true"
            [minDate]="form.get('dataInicio')?.value"
            styleClass="w-full"
            appendTo="body" [autoZIndex]="true" [baseZIndex]="1000010" panelStyleClass="drawer-datepicker-panel"
          >
          </p-datepicker>
          <small class="field-error" *ngIf="hasError('dataTermino')"
            >Campo obrigatório</small
          >
        </div>
      </div>

      <!-- Cobertura toggle -->
      <div class="form-group">
        <label>Cobertura <span class="req">*</span></label>
        <div class="cobertura-toggle">
          @for (opt of coberturaOpts; track opt.value) {
            <button
              type="button"
              class="cob-btn"
              [class.active]="form.get('cobertura')?.value === opt.value"
              (click)="setCoberturaForm(opt.value)"
            >
              <i [class]="opt.icon"></i>
              {{ opt.label }}
            </button>
          }
        </div>
      </div>

      <!-- Substituição -->
      <div class="form-group">
        <div class="check-row">
          <p-checkbox
            formControlName="escalaSubstituicao"
            [binary]="true"
            inputId="sub"
          ></p-checkbox>
          <label for="sub">Esta escala é uma substituição temporária</label>
        </div>
      </div>
    </form>

    <ng-template pTemplate="footer">
      <div class="drawer-footer-actions">
        <button type="button" class="btn-web-secondary" (click)="showDialog = false">
          Cancelar
        </button>
        <button class="btn-web-primary" (click)="save()" [disabled]="submitting">
          <i *ngIf="submitting" class="fas fa-spinner fa-spin"></i>
          <i *ngIf="!submitting" class="fas fa-save"></i>
          {{ submitting ? "A guardar..." : "Guardar" }}
        </button>
      </div>
    </ng-template>
  </p-drawer>
</div>
